export default "__VITE_ASSET__BSfbzo5H__"